module.exports = function() {
  return {
    restrict: 'E',
    link: function(scope) {
      var interval = window.setInterval(function() {
        if (scope.dataLoaded()) {
          clearInterval(interval);
          window.setTimeout(function() {
            window.print();
            window.setTimeout(window.close, 100);
          });
        }
      }, 100);
    }
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/print.js
 ** module id = 153
 ** module chunks = 1
 **/